import React from "react";
import { Link } from "react-router-dom";
import { MessageSquare, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQSection = ({ faqs }) => {
  // Generate FAQ Schema
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <section className="section-padding" data-testid="faq-section">
      {/* Schema Markup */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />

      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-16">
          <div className="lg:sticky lg:top-32 lg:self-start">
            <span className="text-[#00E676] uppercase tracking-wider text-sm font-medium">FAQs</span>
            <h2 className="text-4xl md:text-5xl font-bold mt-4 mb-6">
              Questions About Digital Marketing in Dallas?
            </h2>
            <p className="text-gray-400 text-lg mb-8">
              Get answers to common questions about SEO, AEO, GEO, and our digital marketing services 
              for Dallas businesses.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/contact">
                <Button className="btn-ninja" data-testid="faq-contact-btn">
                  <MessageSquare className="w-5 h-5 mr-2" />
                  Ask Us Anything
                </Button>
              </Link>
              <Link to="/aeo-geo">
                <Button className="btn-outline" data-testid="faq-learn-btn">
                  Learn About AEO & GEO
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Button>
              </Link>
            </div>
          </div>

          <div>
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq) => (
                <AccordionItem 
                  key={faq.id} 
                  value={faq.id}
                  className="border border-white/10 rounded-xl px-6 data-[state=open]:bg-white/5 transition-colors"
                >
                  <AccordionTrigger className="text-left font-medium hover:text-[#00E676] py-5">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-400 pb-5">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
